import React from "react";
import {componentImporter} from "./index";

const componentCaller = (type, props) => {
    const Component = componentImporter(type);
    return <Component key={Math.random()}{...props}/>
};
export default componentCaller;